import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { FieldTypeTextSimpleComponent } from "../../../shared/components/field-type-text/field-type-text-simple/field-type-text-simple.component";
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FieldTypeListSimpleComponent } from "../../../shared/components/field-type-list/field-type-list-simple/field-type-list-simple.component";
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
    selector: 'link-modal',
    templateUrl: './link-modal.component.html',
    standalone: true,
    imports: [AfTranslateDirective, FormsModule, FieldTypeTextSimpleComponent, FieldTypeListSimpleComponent]
})
export class LinkModalComponent implements OnInit {
  node: any = this.dialogConfig.data.node;
  selectedContent: any = this.dialogConfig.data.selectedContent;
  linkModal: any = {
    urlField: {
      label: this.translate.instant('link-modal.url'),
      required: true
    },
    textField: {label: this.translate.instant('link-modal.text-display')},
    titleField: {label: this.translate.instant('link-modal.title')},
    targetField: {
      label: this.translate.instant('link-modal.target'),
      required: true
    },
    targetList: [
      {
        listValueId: '_blank',
        text: this.translate.instant('link-modal.other-window')
      },
      {
        listValueId: '_self',
        text: this.translate.instant('link-modal.same-window')
      }
    ],
    url: '',
    textDisplay: '',
    title: '',
    target: '_blank',
    link: '<a',
    prevLink: false
  }
  constructor(private translate: AfTranslateFactory,
    private modalService: ModalServiceService,
    private dialogRef: DynamicDialogRef<LinkModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    if (this.node) {
      this.linkModal.prevLink = true;
      this.linkModal.url = $(this.node).attr('href');
      this.linkModal.textDisplay = $(this.node).text();
      this.linkModal.title = $(this.node).attr('title');
      this.linkModal.target = $(this.node).attr('target')?$(this.node).attr('target'):'_blank';
    }else if(this.selectedContent){
      this.linkModal.textDisplay = this.selectedContent;
    }
  }

  itemSelected(e:any, type:string){
    this.linkModal[type] = e.newValue;
    if(type === 'url'){
      this.linkModal.urlField.error = false;
      delete this.linkModal.urlField.errorText;
    }else if(type === 'target'){
      this.linkModal.targetField.error = false;
    }
  }

  addLink(){
    if(this.checkLink()){
      if(this.linkModal.textDisplay.trim() === ''){
        this.linkModal.textDisplay = this.linkModal.url;
      }
      if (this.linkModal.url && $.trim(this.linkModal.url) !== '') {
        this.linkModal.link += ' href="' + this.linkModal.url + '"';
      }
      if (this.linkModal.title && $.trim(this.linkModal.title) !== '') {
        this.linkModal.link += ' title="' + this.linkModal.title + '"';
      }
      this.linkModal.link += ' target="' + this.linkModal.target + '">' + this.linkModal.textDisplay + '</a>';
      this.handleAccept();
    }else{
      this.modalService.errorModal({text: this.translate.instant('link-modal.error-configuration')})
    }
  }

  checkLink(){
    this.linkModal.targetField.error = !this.linkModal.target;
    if(!this.linkModal.url){
      this.linkModal.urlField.error = true;
    }else if((this.linkModal.url.indexOf('https://') === -1)){
      this.linkModal.urlField.error = true;
      this.linkModal.urlField.errorText = this.translate.instant('link-modal.http-error');
    }
    return !this.linkModal.urlField.error && !this.linkModal.targetField.error;
  }

  removeLink(){
    this.linkModal.link = this.linkModal.textDisplay;
    this.handleAccept();
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      link: this.linkModal.link,
    });
  };

  handleDismiss() {
    this.dialogRef.close({
      result: 'cancel'
    });
  };
}
